import React, { useEffect, useState } from 'react';
import MagicForm from '../../Form/MagicForm';
import { ItemScheme } from '../../Form/MagicFormItem';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import { MagicField } from '../../../Enums/MagicField.enum';
import usePatientConsent from '../../PatientProfile/Hooks/usePatientConsent';

interface Props {
	onSubmit: (values: FormValues) => void;
	defaultData?: any;
	disableSubmit?: boolean;
	patientId: string;
}

const MedicalReportDetailSerbiaForm: React.FC<Props> = ({
	onSubmit,
	defaultData,
	disableSubmit,
	patientId,
}) => {
	const { isConsentProvided } = usePatientConsent(patientId);

	const [formDefaultData, setFormDefaultData] = useState({
		addToPatientECard: isConsentProvided,
	});

	useEffect(() => {
		setFormDefaultData({
			...defaultData,
			addToPatientECard: isConsentProvided,
		});
	}, [defaultData]);

	// @ts-ignore
	const handleSubmit = async values => {
		onSubmit(values);
	};

	const formScheme: ItemScheme[] = [
		{
			type: MagicField.TEXTAREA,
			key: 'anamnesis',
			title: 'Anamneza',
		},
		{
			type: MagicField.TEXTAREA,
			key: 'objectiveFinding',
			title: 'Objektivni nalaz',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXTAREA,
			key: 'diagnosis',
			title: 'Dijagnoza',
		},
		{
			type: MagicField.TEXTAREA,
			key: 'therapy',
			title: 'Terapja',
		},
		{
			type: MagicField.TEXTAREA,
			key: 'parameters',
			title: 'Parametri',
		},
		{
			type: MagicField.TEXTAREA,
			key: 'control',
			title: 'Kontrola',
		},
	];

	if (isConsentProvided) {
		formScheme.push(
			{
				type: MagicField.WHITESPACE,
			},
			{
				type: MagicField.CHECKBOX,
				key: 'addToPatientECard',
				title: 'component.medicalRequestCreate.addToPatientsECard',
			},
		);
	} else {
		formScheme.push(
			{
				type: MagicField.PATIENT_CONSENT_REQUEST,
				settings: {
					patientId,
				},
			},
			{
				type: MagicField.WHITESPACE,
			},
		);
	}

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			defaultValues={formDefaultData}
			disableSubmit={disableSubmit}
		/>
	);
};

export default MedicalReportDetailSerbiaForm;
